import PropType from "prop-types";
import { useCallback, useState } from "react";
import { useTranslate } from "../../../../language/i18n";
import clientService from "../../../../services/client/clientService";
import FacilitySelector from "../../../shared/FacilitySelector/FacilitySelector";
import LocationSelector from "../../../shared/LocationSelector/LocationSelector";
import ConfirmModal from "../../../shared/Modals/ConfirmModal";
import styles from "../Holding.module.scss";

const ReturnModal = ({ clientId, visible, onClose, selectedProducts }) => {
  const translate = useTranslate();
  const [selected, setSelected] = useState();
  const [selectedLocation, setSelectedLocation] = useState();

  const onSubmit = async () => {
    const response = await clientService.returnHoldingsToBaseStorage({
      clientId,
      data: selectedProducts,
      toLocationId: selectedLocation?.id,
    });
    if (response.isOk()) {
      return response;
    }
  };

  return (
    <ConfirmModal
      title={translate("RETURN_TO_BASE_STORAGE")}
      text={translate("RETURN_TO_BASE_STORAGE_DESCRIPTION")}
      visible={visible}
      cancel={onClose}
      small={false}
      submit={() => onSubmit().then(() => location.reload())}
      customCssClass={styles.returnModal}
      confirmButtonDisabled={!selected && !selectedLocation}
    >
      <FacilitySelector
        preSelected={selected}
        onSelect={useCallback(baseStorage => {
          setSelected(baseStorage);
          setSelectedLocation(undefined);
        }, [])}
      />
      {selected && (
        <LocationSelector baseStorageId={selected.id} onSelect={setSelectedLocation} preSelected={selectedLocation} />
      )}
    </ConfirmModal>
  );
};

ReturnModal.propTypes = {
  clientId: PropType.string,
  visible: PropType.bool,
  onClose: PropType.func,
  selectedProducts: PropType.array,
};

export default ReturnModal;
